import BaseModel from './base';
// import {
//   DIRECTORY_MEMBER_TYPE,
//   DIRECTORY_USER_ATTRIBUTE_TITLE,
//   DIRECTORY_ID,
//   DIRECTORY_TITLE,
// } from '@/modules/UserProfile/components/Profile/Sections/constants';

export default class UserAttribute extends BaseModel {
  constructor(attribute) {
    super(attribute);

    this.id = attribute.id;
    this.directory_member_type = attribute.directory_member_type;
    this.directory_id = attribute.directory_id;
    [this.value] = attribute.values;
  }
}
